import React, { useState } from 'react';

interface ChipSelectorProps {
    options: string[];
    defaultSelection?: string | null;
    onSelect: (option: string) => void;
    disabledOptions?: Set<string>;
}

const ChipSelector = ({ options, defaultSelection = null, onSelect, disabledOptions = new Set() }: ChipSelectorProps) => {
    const [selected, setSelected] = useState<string | null>(defaultSelection);

    return (
        <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
            {options.map((option) => {
                const isDisabled = disabledOptions.has(option);
                return (
                    <button
                        key={option}
                        onClick={() => {
                            if (!isDisabled) {
                                onSelect(option);
                                setSelected(option);
                            }
                        }}
                        className={`button-outline${selected === option ? ' selected' : ''}`}
                        disabled={isDisabled}
                        style={{ opacity: isDisabled ? 0.5 : 1, cursor: isDisabled ? 'not-allowed' : 'pointer' }}
                    >
                        {option}
                    </button>
                );
            })}
        </div>
    );
};

export default ChipSelector;